<div
  class="company-sub-block-card"
  [ngClass]="{ 'company-sub-block-card-margin-top': isMarginTop, 'company-sub-block-card-margin-bottom': isMarginBottom }"
>
  <div class="company-sub-block-card-header" *ngIf="subTitle">
    <div class="company-sub-block-card-header-title-wrapper">
      <h4 class="company-sub-block-card-header-title">{{ subTitle | translate }}</h4>

      <div class="company-sub-block-card-header-hint" *ngIf="subHint">
        <app-hint-tooltip-icon [hint]="subHint | translate"></app-hint-tooltip-icon>
      </div>

      <span class="company-sub-block-card-header-required" *ngIf="isShowRequired">{{ "LABELS.REQUIRED" | translate }}</span>
      <span class="company-sub-block-card-header-optional" *ngIf="isShowOptional">{{ "LABELS.OPTIONAL" | translate }}</span>
    </div>

    <div class="company-sub-block-card-header-actions">
      <ng-content select="[inner-card-actions]"></ng-content>
    </div>
  </div>

  <div class="company-sub-block-card-body">
    <ng-content select="[inner-card-body]"></ng-content>
  </div>

  <div class="company-sub-block-card-footer" *ngIf="isShowFooter">
    <ng-content select="[inner-card-footer]"></ng-content>
  </div>
</div>
